module.exports = __webpack_public_path__ + "static/18-47f4c2d495e86123aee29baeb1cd40a1.png";